import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ItemContainer, LinkContainer, Image, ReferralHeader } from "./Referral.styles";
export var ReferralImageBox = function(param) {
    var title = param.title, href = param.href, imageSource = param.imageSource, imageFallback = param.imageFallback;
    return /*#__PURE__*/ _jsx(ItemContainer, {
        children: /*#__PURE__*/ _jsxs(LinkContainer, {
            href: href,
            children: [
                /*#__PURE__*/ _jsx(ReferralHeader, {
                    children: title
                }),
                /*#__PURE__*/ _jsx(Image, {
                    src: imageSource,
                    alt: imageFallback
                })
            ]
        })
    });
};
